import React, { useState } from "react";
import { motion, easeInOut } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { SectionTitle, Text } from "../../components/styledComponent";
import DealerImg from "../../assets/newWholesaleIconOne.webp";
import RealtorImg from "../../assets/newWholesaleIconTwo.webp";
import VendorImg from "../../assets/newWholesaleIconThree.webp";
import CancoMoney from "../../assets/newWholesaleIconFour.webp";
import styles from "./style.module.scss";
import { WholesaleBusinessContactForm } from "../../components/parts/forms";
import { BuildingFill, TelephoneFill } from "react-bootstrap-icons";
import { Loader } from "../../components/ui";
import successGif from "../../assets/successGif.gif";

const WholesaleBusiness = () => {
  const [loader, setLoader] = useState(false);
  const [successBox, setSuccessBox] = useState(false);
  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };
  const contactDetailsArr = [
    <motion.div className={styles.detail} variants={item}>
      <div>
        <TelephoneFill color="var(--primaryColor)" size={35} />
      </div>
      <div>
        <h3>PHONE</h3>
        <Text>+1 (236) 420-0688</Text>
      </div>
      <a href="tel:+12364200688">link</a>
    </motion.div>,
    // <motion.div className={styles.detail} variants={item}>
    //   <div>
    //     <EnvelopeFill color="var(--primaryColor)" size={35} />
    //   </div>
    //   <div>
    //     <h3>MAIL</h3>
    //     <Text>inquiry@cancopetroleum.ca</Text>
    //   </div>
    //   <a href="mailto:inquiry@cancopetroleum.ca">link</a>
    // </motion.div>,
    // <motion.div className={styles.detail} variants={item}>
    //   <div>
    //     <PrinterFill color="var(--primaryColor)" size={35} />
    //   </div>
    //   <div>
    //     <h3>FAX</h3>
    //     <Text>(236) 420 0689</Text>
    //   </div>
    //   <a href="fax:2364200689">link</a>
    // </motion.div>,
    <motion.div className={styles.detail} variants={item}>
      <div>
        <BuildingFill color="var(--primaryColor)" size={35} />
      </div>
      <div>
        <h3>HEAD OFFICE</h3>
        <Text>#200 - 125 Highway 33 E Kelowna, BC V1X 2A1</Text>
      </div>
      <a href="/">link</a>
    </motion.div>,
  ];
  return (
    <div className={styles.businessPage}>
      {/* Banner section */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.3, easings: easeInOut }}
        className={styles.bannerSection}
      ></motion.div>

      {/* Lets do business section */}
      <Container className={`sectionContainer ${styles.businessSection}`}>
        <Row>
          <Col>
            <SectionTitle $textAlign="center">
              Quality Fuel and Service You Can Trust On
            </SectionTitle>
            <Container fluid className={styles.businessPointer}>
              <Row>
                <Col xs={12} md={6} lg={3}>
                  <img src={DealerImg} alt="Dealer" />
                  <SectionTitle>Direct Refinery Sourcing</SectionTitle>
                  <Text>
                    Premium fuel sourced directly from leading Canadian
                    refineries, ensuring superior quality and consistency for
                    all your needs.
                  </Text>
                  {/* <Anchor href="/become-dealer">DEALER APPLICATION</Anchor> */}
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <img src={RealtorImg} alt="Realtor" />
                  <SectionTitle>Customer Support</SectionTitle>
                  <Text>
                    Our support team is here to assist with any questions or
                    concerns, committed to providing excellent customer service
                    and keeping your operations running smoothly.
                  </Text>
                  {/* <Anchor href="/become-vendor">VENDOR APPLICATION</Anchor> */}
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <img src={VendorImg} alt="Vendor" />

                  <SectionTitle>Reliable Service Network</SectionTitle>
                  <Text>
                    Partnering with reputable carriers across Canada, including
                    remote areas, to guarantee reliable and timely delivery of
                    our fuel products.
                  </Text>
                  {/* <Anchor href="/become-realtor">REALTOR APPLICATION</Anchor> */}
                </Col>
                <Col xs={12} md={6} lg={3}>
                  <img src={CancoMoney} alt="Canco Money" />
                  <SectionTitle>Flexible Pricing Options</SectionTitle>
                  <Text>
                    Offering competitive and flexible pricing to help you save
                    money, with solutions designed to fit your budget and
                    maximize value.
                  </Text>
                  {/* <Anchor href="/become-realtor">REALTOR APPLICATION</Anchor> */}
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>

      {/* Why canco section*/}
      <div className={styles.whyCancoSection}>
        <Container className={`sectionContainer`}>
          <Row>
            <Col>
              {/* <SectionTitle>WHY CANCO?</SectionTitle> */}
              <Text $textAlign="center" $size="3.2rem">
                Committed to supplying high quality fuel with reliability and
                efficiency.
                <br />
                Persistent focus on safety, sustainability, and supporting
                communities in their growth.
              </Text>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Pointer section */}
      {/* <CancoPointerSection /> */}

      {/* Contact Form section */}
      <div className={styles.contactFormSection}>
        <Container>
          <Row>
            <Col lg={6}>
              <SectionTitle>Get In Touch With Us</SectionTitle>
              {!successBox && (
                <WholesaleBusinessContactForm
                  loader={(val) => setLoader(val)}
                  success={(val) => setSuccessBox(val)}
                />
              )}
              {loader && (
                <div className={styles.loaderBox}>
                  <Loader />
                </div>
              )}
              {successBox && (
                <div className={styles.successBox}>
                  <img src={successGif} alt="Success" />
                  <h3>
                    Thank you
                    <br />
                    Your response is submitted successfully.
                  </h3>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      {/* Gallery section */}
      {/* <Container className={`sectionContainer ${styles.gallerySection}`}>
        <Row className={styles.firstGalleryRow}>
          <Col xs={12} md={6} lg={6}>
            <img src={firstGalleryImg} alt="Gallery" />
          </Col>
          <Col xs={12} md={4} lg={4}>
            <img src={secondGalleryImg} alt="Gallery" />
          </Col>
          <Col xs={12} md={2} lg={2}>
            <img src={thirdGalleryImg} alt="Gallery" />
          </Col>
        </Row>
        <Row className={styles.secondGalleryRow}>
          <Col xs={12} md={4} lg={4}>
            <img src={fourGalleryImg} alt="Gallery" />
          </Col>
          <Col xs={12} md={4} lg={4}>
            <img src={fiveGalleryImg} alt="Gallery" />
          </Col>
          <Col xs={12} md={4} lg={4}>
            <img src={sixGalleryImg} alt="Gallery" />
          </Col>
        </Row>
        <Row className={styles.thirdGalleryRow}>
          <Col xs={12} md={2} lg={2}>
            <img src={sevenGalleryImg} alt="Gallery" />
          </Col>
          <Col xs={12} md={4} lg={4}>
            <img src={eightGalleryImg} alt="Gallery" />
          </Col>
          <Col xs={12} md={6} lg={6}>
            <img src={nineGalleryImg} alt="Gallery" />
          </Col>
        </Row>
      </Container> */}

      {/* <Container className={`sectionContainer ${styles.canadaSection}`}>
        <Row>
          <Col>
            <img src={CanadaLeaf} alt="Canada Leaf" />
            <SectionTitle>Canadian born and raised</SectionTitle>
          </Col>
        </Row>
      </Container> */}
      <Container className={`sectionContainer ${styles.contactDetail}`}>
        <Row>
          <Col>
            <motion.div
              className={styles.detailBlock}
              variants={container}
              initial="hidden"
              whileInView="visible"
            >
              {contactDetailsArr.map((item) => item)}
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WholesaleBusiness;
